/**
 * Simple cookie utilities for client-side usage
 */

export function getCookie(name: string): string | null {
  if (typeof document === 'undefined') {
    return null;
  }

  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) {
    return parts.pop()?.split(';').shift() ?? null;
  }
  return null;
}

export function setCookie(
  name: string,
  value: string,
  maxAge: number = 60 * 60 * 24 * 7, // 7 days default
): void {
  if (typeof document === 'undefined') {
    return;
  }

  document.cookie = `${name}=${value}; path=/; max-age=${maxAge}`;
}
